import { LucideIcon, MoreHorizontal } from 'lucide-react';

import {
    SidebarGroup,
    SidebarMenu,
    SidebarMenuAction,
    SidebarMenuButton,
    SidebarMenuItem,
    useSidebar,
} from '@/components/ui/sidebar';

import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { MenuGroupItems, NavSectionItems } from '@/types';

export function NavSection({
    header,
    items,
    menuGroupItems,
}: {
    header: { title: string; icon: LucideIcon };
    items: NavSectionItems;
    menuGroupItems: MenuGroupItems;
}) {
    const { isMobile } = useSidebar();
    const navigate = useNavigate();
    const [params, _] = useSearchParams();
    const conversationId = params.get('conversationId');

    return (
        <SidebarGroup>
            <SidebarMenu>
                <SidebarMenuButton tooltip={header.title}>
                    <header.icon />
                    <span>{header.title}</span>
                </SidebarMenuButton>
                {items?.map(subItem => (
                    <SidebarMenuItem
                        key={subItem.url}
                        className={
                            'highlight-menu-item ml-2 rounded-md ' + (subItem.id === conversationId && 'bg-white/5')
                        }
                    >
                        <SidebarMenuButton asChild>
                            <div className='cursor-pointer' onClick={() => navigate(subItem.url)}>
                                {subItem.isHtml ? (
                                    <span dangerouslySetInnerHTML={{ __html: subItem.title as string }} />
                                ) : (
                                    <span>{subItem.title}</span>
                                )}
                            </div>
                        </SidebarMenuButton>
                        <DropdownMenu>
                            <DropdownMenuTrigger asChild className='transition-all'>
                                <SidebarMenuAction showOnHover className='cursor-pointer'>
                                    <MoreHorizontal />
                                    <span className='sr-only'>More</span>
                                </SidebarMenuAction>
                            </DropdownMenuTrigger>
                            <DropdownMenuContent
                                className='w-48 rounded-lg bg-slate-800/30 backdrop-blur-md'
                                side={isMobile ? 'bottom' : 'right'}
                                align={isMobile ? 'end' : 'start'}
                            >
                                {menuGroupItems.map(item => (
                                    <DropdownMenuItem
                                        key={item.id}
                                        className='highlight-menu-item'
                                        onClick={() => item.action?.(subItem.id)}
                                    >
                                        <item.icon className='text-muted-foreground' />
                                        <span>{item.title}</span>
                                    </DropdownMenuItem>
                                ))}
                            </DropdownMenuContent>
                        </DropdownMenu>
                    </SidebarMenuItem>
                ))}
            </SidebarMenu>
        </SidebarGroup>
    );
}
